<template>
  <m-input-select
    fullwidth
    v-bind="$attrs"
    :options="options"
    v-on="listeners"
    @input="$emit('input', $event)"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'

  export default {
    name: 'ComponentSelect',
    components: { MInputSelect },
    inheritAttrs: false,
    computed: {
      listeners () {
        const { input, ...inherited } = this.$listeners
        return {
          ...inherited
        }
      },
      options () {
        return [
          {
            value: 'bridge',
            label: 'Bridge'
          },
          {
            value: 'rng',
            label: 'RNG'
          },
          {
            value: 'cpv',
            label: 'CPV'
          },
          {
            value: 'reporting',
            label: 'Reporting'
          }
        ]
      },
    },
  }
</script>

<style scoped>

</style>
